<template>
  <div class="title-box" v-if="moduleData.componentList.length">
    <span class="title">{{ moduleData.title }}</span>
  </div>
  <div class="custom-subList" v-if="moduleData.componentList.length">
    <el-table
      class="custom-table"
      :data="tableData"
      border
      style="width: 100%"
      header-cell-class-name="custom-header"
      @header-dragend="handleDragendColumn"
    >
      <template v-for="(item, index) in dynamicColumns" :key="index">
        <el-table-column
          v-if="item.show"
          min-width="150px"
          :label="item.title"
          :width="curCacheData[item.fieldSerial] || ''"
        >
          <template #header>
            <span class="required-icon">{{ showMust(item) ? '*' : '' }}</span>
            <span>{{ item.name }}</span>
          </template>
          <template #default="scope">
            <div class="val">
              <Render
                :sceneType="SceneTypeEnum.ADD_FORM"
                :data="item"
                :index="scope.$index"
                ref="renderRef"
                :comp-name="item.renderConfig.compName"
                :renderConfig="item.renderConfig"
                :quoteMappingConfig="quoteMappingConfig"
                :value="getValue(item, scope.row)"
                @changeValue="value => changeValue(value, item, scope.row)"
                @refreshDataList="value => refreshDataList(value, item)"
                :isTxt="!scope.row.isEdit"
                :positions="positions"
                isSubTable
                @refreshSubListRowDataId="refreshSubListRowDataId"
                :formData="formData"
              />
            </div>
          </template>
        </el-table-column>
      </template>

      <el-table-column label="操作" fixed="right" width="180px">
        <template #default="scope">
          <div>
            <RxkButton text @click="handleOperate(scope.row)">
              {{ scope.row.isEdit ? '确认' : '编辑' }}
            </RxkButton>
            <RxkButton text v-if="tableData.length > 1" @click="handleDelete(scope.$index)">
              删除
            </RxkButton>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      class="addRow pointer"
      type="text"
      v-if="multipleData() && addData()"
      @click="addTableRow"
    >
      +新增一行
    </el-button>
  </div>
</template>
<script setup lang="tsx">
import { onMounted, type PropType, ref, unref, watch } from 'vue'
import { ColumnType } from '@/types/table'
import {
  dealFormValConfig,
  getTableColumnWidthByCode,
  ruleStrategy
} from '@/utils/preObjectManage/utils'
import Render from '@/components/custom/form/components/render.vue'
import { cloneDeep } from '@/utils/tools'
import { formulaEmitter } from '@/utils/business/formulaEmitter'
import { fieldTypeConfig, fieldTypeEnum, operateListEnum } from '@/enums/preObjectManage'
import { isNullOrUndefOrEmpty, isFunc } from '@/utils/is'
import { SceneTypeEnum } from '@/enums/business'

const props = defineProps({
  moduleData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  positions: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  quoteMappingConfig: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  subListData: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})
const emit = defineEmits(['changeValue'])
const associaFormCondition = inject('associaFormCondition') as Recordable[]

function handleOperate(data: Recordable) {
  data.isEdit = !data.isEdit
  if (!data.isEdit) {
    emit('changeValue', getSubListData())
  }
  console.log(tableData, 'tableData')
}
const equationList = inject('equationList') as Recordable[]

// 是否显示必填
function showMust(item: Recordable) {
  console.log(item, 'item222333')
  const current = item.columnOperateList.find((operate: Recordable) => {
    return operate.value && operate.code === operateListEnum.MUST
  })
  return !!current
}

const tableData = ref<Recordable[]>([])
// 获取值
function getValue(data: Recordable, form: Recordable) {
  const { fieldCode, code, fieldType } = data
  let customCode = code
  // 引用字段
  if (
    fieldType === fieldTypeEnum.SYS_QUOTE ||
    fieldType === fieldTypeEnum.CUSTOM_QUOTE ||
    fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
    fieldType === fieldTypeEnum.SON_CUSTOM_QUOTE
  ) {
    customCode = fieldTypeConfig.quote
  }
  // 映射字段
  if (
    fieldType === fieldTypeEnum.SYS_MAPPING ||
    fieldType === fieldTypeEnum.CUSTOM_MAPPING ||
    fieldType === fieldTypeEnum.SON_SYS_MAPPING ||
    fieldType === fieldTypeEnum.SON_CUSTOM_MAPPING
  ) {
    customCode = fieldTypeConfig.mapping
  }
  const getValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].getValue
    : () => form[fieldCode] || ''
  return getValueFn(data, form)
}
// 修改表单的值
function changeValue(value: any, data: Recordable, form: Recordable) {
  console.log(data, form, 'ppp')
  const { fieldCode, code, fieldType } = data
  let customCode = code
  // 引用字段
  if (
    fieldType === fieldTypeEnum.SYS_QUOTE ||
    fieldType === fieldTypeEnum.CUSTOM_QUOTE ||
    fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
    fieldType === fieldTypeEnum.SON_CUSTOM_QUOTE
  ) {
    customCode = fieldTypeConfig.quote
  }
  // 映射字段
  if (
    fieldType === fieldTypeEnum.SYS_MAPPING ||
    fieldType === fieldTypeEnum.CUSTOM_MAPPING ||
    fieldType === fieldTypeEnum.SON_SYS_MAPPING ||
    fieldType === fieldTypeEnum.SON_CUSTOM_MAPPING
  ) {
    customCode = fieldTypeConfig.mapping
  }
  const setValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].setValue
    : () => {
        form[fieldCode] = value
      }
  setValueFn(value, data, form)

  // 只要是数字，金额，百分比就去触发
  if (
    code === fieldTypeConfig.number ||
    code === fieldTypeConfig.money ||
    code === fieldTypeConfig.percentage
  ) {
    formulaEmitter(unref(equationList), data, tableData, props?.moduleData?.componentList)
  }

  if (unref(associaFormCondition).length) {
    unref(associaFormCondition).forEach(item => {
      const cur = item.columnSerials.find(serial => serial === data.fieldSerial)
      if (cur) {
        item.Emitter.emit('associaForm', item.moduleSerial)
      }
    })
  }
}
function refreshDataList(value: any, item: Recordable) {
  item.dataList = value
  item.renderConfig.dataList = value
}
function refreshSubListRowDataId(data: Recordable) {
  tableData.value[data.index].quoteDataId = data.quoteDataId
}

const dynamicColumns = ref<Recordable[]>([])

const defaultRowData: Recordable = ref({})
function addTableRow() {
  if (tableData.value.length) {
    tableData.value[tableData.value.length - 1].isEdit = false
  }
  const cloneData = cloneDeep({ ...unref(defaultRowData), isEdit: true })
  tableData.value.push(cloneData)
  console.log(tableData, 'tableData1122')
}
function handleDelete(index: any) {
  if (tableData.value.length <= 1) {
    ElMessage.error('至少有一行')
    return
  }
  tableData.value.splice(index, 1)
}
// 使用策略模式设置表格的列
function setTableColumns() {
  const obj: Recordable = {}
  props.moduleData.componentList.forEach((field: Recordable) => {
    const { fieldCode } = field.columnInfo
    obj[fieldCode] = ''
  })
  // 生成默认的表格数据
  defaultRowData.value = { ...obj, isEdit: false }
}

onMounted(() => {
  setTableColumns()
  createTableColumns()
  addTableRow()
  getTableData()
  dealCacheColumnWidth()
})
watch(
  () => props.subListData,
  () => {
    getTableData()
  }
)

/* --------------------------------table列宽的缓存处理-------------------------------- */
// 当前子表单列宽缓存key：为了避免重复，采用【模块id + 容器id】组合
const curCacheKey = computed(() =>
  [props?.moduleData?.id, props?.moduleData?.containerId].join('&&')
)
// 当前子表单的列宽缓存数据
const curCacheData = ref<Recordable>({})

/**
 * @description: 获取当前的子表单列宽缓存数据
 */
function getAllColWidthCacheData() {
  return JSON.parse(localStorage.getItem('SUBLIST_COLUMN_WIDTH_CACHE') || '{}')
}

/**
 * @description: 处理表格组件的缓存列宽
 */
function dealCacheColumnWidth() {
  const cache = getAllColWidthCacheData()[curCacheKey.value]
  cache && (curCacheData.value = cache)
}

/**
 * @description: 缓存手动拖拽后的列宽
 * @param newWidth 拖动后列宽
 * @param _oldWidth 拖动前列宽
 * @param column 字段信息
 */
function handleDragendColumn(newWidth: number, _oldWidth: number, column: Recordable) {
  const _columnSerial = unref(dynamicColumns)?.find(item => item.title === column.label)
    ?.columnSerial
  const originData = getAllColWidthCacheData()
  const finalData = {
    ...originData, // 不影响全局的其它应用子表单数据
    [curCacheKey.value]: {
      ...(originData[curCacheKey.value] || {}), // 不影响同一应用其它子表单数据
      [_columnSerial]: newWidth
    }
  }
  if (_columnSerial) {
    localStorage.setItem('SUBLIST_COLUMN_WIDTH_CACHE', JSON.stringify(finalData))
  }
}

// 重新发起处理值的回显
function getTableData() {
  if (props.subListData?.length) {
    tableData.value =
      props.subListData
        ?.filter((item: Recordable) => item.moduleGroup === props.moduleData?.group)
        .map((el: any) => {
          let colMap =
            props?.moduleData?.componentList?.map((col: Recordable) => ({
              fieldSerial: col.fieldSerial,
              fieldCode: col.fieldCode
            })) || []
          let obj: any = {}
          colMap.forEach((col: Recordable) => {
            obj[col.fieldCode] = el[col.fieldSerial]
          })
          return {
            ...obj,
            ...el
          }
        }) || []
  }
}
function createTableColumns() {
  dynamicColumns.value = props.moduleData.componentList.map((field: Recordable) => {
    const { fieldCode, name, code } = field.columnInfo
    let resultObj: ColumnType = {
      key: fieldCode,
      title: name
    }
    // 设置每列的最小宽度,不手动设置的话则以通用规则设置
    if (!resultObj.minWidth && !resultObj.width) {
      resultObj.minWidth = getTableColumnWidthByCode(code)
    }
    // resultObj = JSON.parse(JSON.stringify(field))
    resultObj.fieldConfig = field
    return { ...resultObj, ...field }
  })
  console.log(dynamicColumns, 'dynamicColumns111')
}

function getSubListData() {
  console.log(tableData.value, 'JSON.parse(JSON.stringify(tableData.value))')
  const copyData = JSON.parse(JSON.stringify(tableData.value))
  // @todo 后面再校验值
  return copyData.map(item => {
    delete item.isEdit
    return { ...item }
  })
}

// 验证表格数据
function validateTableData() {
  console.log(props.moduleData.show, 'props.moduleData.show')
  if (!props.moduleData.show) {
    return true
  }
  // 在验证遍历的时候就处理这些数据
  const dataList: Recordable[] = []
  const flag = tableData.value.every((row, index: any) => {
    const obj: Recordable = {
      id: row.id
    }
    const rowFlag = dynamicColumns.value.every((i, index) => {
      console.log(i, 'i444')
      let value = row[i.fieldCode]
      if (i.renderConfig.valCallback) {
        value = i.renderConfig.valCallback(row[i.fieldCode], i)
      }
      console.log(value, 'value1233')
      const current = i.columnOperateList.find((operate: Recordable) => {
        return operate.value && operate.code === operateListEnum.MUST
      })
      // 必填
      if (current) {
        if (isNullOrUndefOrEmpty(value)) {
          ElMessage.error(`${props.moduleData.title}-第${index + 1}列("${i.name}")必填`)
          return false
        }
      }
      const otherValid = ruleStrategy[i.code]
      if (otherValid) {
        const validConfig = otherValid(i, true)
        if (isFunc(validConfig.validateFn)) {
          const errMsg = validConfig.validateFn(value)
          if (errMsg) {
            ElMessage.error(
              `在子表-${props.moduleData.title}-第${index + 1}列("${i.name}")处,${errMsg}`
            )
            return false
          }
        } else {
          if (!isNullOrUndefOrEmpty(value) && !validConfig?.reg?.test(value)) {
            ElMessage.error(
              `在子表-${props.moduleData.title}-第${index + 1}列("${i.name}")处,${
                validConfig.errMsg
              }`
            )
            return false
          }
        }
      }
      obj[i.fieldCode] = value
      return true
    })
    dataList.push(obj)
    console.log(rowFlag, 'rowFlagrowFlagrowFlagrowFlagrowFlagrowFlag')
    return rowFlag
  })
  // 验证成功直接返回接口所需数据, 失败返回false
  // 必填验证成功之后，还需要根据必填校验，
  if (flag && mustData()) {
    let flag1 = false
    dataList.forEach(item => {
      Object.keys(item).forEach(key => {
        if (!isNullOrUndefOrEmpty(item[key])) {
          flag1 = true
          return
        }
      })
    })
    if (!flag1) {
      ElMessage.error(`${props.moduleData.title}数据必填`)
    }
    return flag1 ? dataList : flag1
  }
  return flag ? dataList : flag
}
defineExpose({
  validateTableData,
  getSubListData
})

// 是否允许添加多行数据
function multipleData() {
  if (props.moduleData.operateList) {
    const current = props.moduleData?.operateList.find(
      item => item.code === 'MODULE:ALLOW_MULTIPLE_DATA'
    )
    return current ? current.value : false
  } else {
    return false
  }
}
// 是否可以新增记录
function addData() {
  console.log(props.moduleData, 'moduleData')
  if (props.moduleData.operateList) {
    const current = props.moduleData.operateList.find(item => item.code === 'MODULE:ADD_DATA')
    return current ? current.value : false
  } else {
    return false
  }
}
// 是否必填
function mustData() {
  console.log(props.moduleData, 'moduleData')
  if (props.moduleData.operateList) {
    const current = props.moduleData.operateList.find(item => item.code === 'MODULE:MUST')
    return current ? current.value : false
  } else {
    return false
  }
}
</script>
<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}
.custom-subList {
  width: 100%;
  height: 100%;
  margin-top: 16px;
  // padding: 0 16px;
  &.reHeight {
    height: calc(100% - 65px);
  }

  :deep(.el-table__body) {
    .el-table__cell {
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-right-color: transparent;
      .cell {
        line-height: 40px;
        font-size: 14px;
        color: #333333;
      }
    }
  }
  :deep(.custom-header) {
    padding: 0;
    height: 40px;
    line-height: 40px;
    background: #f4f4f5 !important;
    .cell {
      line-height: 40px;
      font-size: 14px;
      color: #666666;
      font-weight: 700;
    }
  }
}
.addRow {
  color: #5687ff;
  display: inline-block;
}
.required-icon {
  color: #f56c6c;
}
</style>
